<div *ngIf="editing else off">
	<form #f='ngForm' autocomplete="off"
		  [ngSwitch]="observationVariable.dataTypeId" (keyup.enter)="submit(f)" (keyup.escape)="cancel()">
		<div *ngSwitchCase="DataTypeIdEnum.CHARACTER">
			<input type="{{isEncrypted ? 'password' : 'text'}}" class="form-control" name="editorInput" #editorInput [(ngModel)]="value" (blur)="submit(f)"/>
		</div>
		<div *ngSwitchCase="DataTypeIdEnum.NUMERIC">
			<input type="number" class="form-control" name="editorInput" #editorInput [(ngModel)]="value" (blur)="submit(f)"/>
		</div>
		<div *ngSwitchCase="DataTypeIdEnum.CATEGORICAL">
			<ng-select name="editorInput" #editorInput
					   [items]="observationVariable.possibleValues" [(ngModel)]="value"
					   bindValue="name" bindLabel="name"
					   [searchFn]="searchCategorical"
					   (blur)="submit(f)"
					   [dropdownPosition]="'bottom'">
				<ng-template ng-option-tmp let-possibleValue="item">
					<div title="{{possibleValue.description}}">{{possibleValue.name}}</div>
				</ng-template>
			</ng-select>
		</div>
		<div *ngSwitchCase="DataTypeIdEnum.DATE">
			<div class="input-group">
				<input class="form-control" [placeholder]="'global.date.placeholder' | translate"
					   name="editorInput" [(ngModel)]="dateValue"
					   ngbDatepicker #editorInput="ngbDatepicker"
					   container="body"
					   (click)="editorInput.open()"
					   (closed)="submitDate(f)"
				/>
			</div>
		</div>
	</form>
</div>
<ng-template #off>
	<div (click)="edit()">
		<ng-content></ng-content>
	</div>
</ng-template>
